<template>
  <canvas
    ref="confettiCanvas"
    :class="$style.confetti"
  />
</template>

<script
  lang="ts"
  setup
>
import ConfettiGenerator from 'confetti-js';
import { Fireworks } from 'fireworks-js';
import { onMounted, onUnmounted, ref } from 'vue';
import dayjs from '@/dayjs';

// Template ref for the canvas element
const confettiCanvas = ref<HTMLCanvasElement | null>(null);

// Store references to our generators for cleanup
const confettiGenerator = ref<ConfettiGenerator | null>(null);
const fireworksGenerator = ref<Fireworks | null>(null);

const isNewYearCelebration = (): boolean => {
  const now = dayjs();
  return now.month() === 0 && now.date() === 1;
};

onMounted(() => {
  if (!confettiCanvas.value) return;

  if (isNewYearCelebration()) {
    fireworksGenerator.value = new Fireworks(confettiCanvas.value, {
      intensity: 15,
    });
    fireworksGenerator.value.start();
  } else {
    const confettiSettings = { target: confettiCanvas.value };
    confettiGenerator.value = new ConfettiGenerator(confettiSettings);
    confettiGenerator.value.render();
  }
});

onUnmounted(() => {
  // Clean up confetti generator
  if (confettiGenerator.value) {
    confettiGenerator.value.clear();
    confettiGenerator.value = null;
  }

  // Clean up fireworks generator
  if (fireworksGenerator.value) {
    fireworksGenerator.value.stop();
    fireworksGenerator.value = null;
  }
});
</script>

<style
  lang="scss"
  module
>
.confetti {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}
</style>
